var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { ScissorsIcon } from "@radix-ui/react-icons";
import client from "../../http/client";
import { RadixButton } from "../primitives/RadixButton";
import { RadixInput } from "../primitives/RadixInput";
import { RadixModal } from "../primitives/RadixModal";
import "./discountsSection.css";
import { useAuth } from "../../providers";
import { discountsSectionSchema } from "./discountsSectionSchema";
var toOffer = function (candidate, index) {
    if (!candidate || typeof candidate !== "object") {
        return null;
    }
    var offerRecord = candidate;
    var code = String(offerRecord.PromoCode || "").trim();
    if (!code) {
        return null;
    }
    var title = String(offerRecord.Offer || "Reward offer").trim() || "Reward offer";
    var expiresRaw = String(offerRecord.ExpDate || "").trim();
    return {
        id: String(offerRecord.PK || code || index),
        code: code,
        title: title,
        expiresLabel: expiresRaw,
    };
};
var normalizeDiscountCode = function (code) {
    return code.trim().toLowerCase();
};
var isOfferExpired = function (expiresLabel) {
    var normalizedExpiration = String(expiresLabel || "").trim();
    if (!normalizedExpiration) {
        return false;
    }
    var parsedExpiration = new Date(normalizedExpiration);
    if (Number.isNaN(parsedExpiration.getTime())) {
        return false;
    }
    parsedExpiration.setHours(23, 59, 59, 999);
    return parsedExpiration.getTime() < Date.now();
};
export var DiscountsSection = function (_a) {
    var _b;
    var offers = _a.offers, appliedCodes = _a.appliedCodes, _c = _a.initialManualCode, initialManualCode = _c === void 0 ? "" : _c, onApplyDiscount = _a.onApplyDiscount, onRemoveDiscount = _a.onRemoveDiscount;
    var _d = useState(null), applyingCode = _d[0], setApplyingCode = _d[1];
    var _e = useState(null), removingCode = _e[0], setRemovingCode = _e[1];
    var _f = useState(""), feedbackMessage = _f[0], setFeedbackMessage = _f[1];
    var _g = useState(null), feedbackType = _g[0], setFeedbackType = _g[1];
    var _h = useState(false), isRelevanceLoading = _h[0], setIsRelevanceLoading = _h[1];
    var _j = useState(false), nonRelevantModalOpen = _j[0], setNonRelevantModalOpen = _j[1];
    var _k = useState({}), offerRelevanceByCode = _k[0], setOfferRelevanceByCode = _k[1];
    var user = useAuth().user;
    var _l = useForm({
        resolver: zodResolver(discountsSectionSchema),
        mode: "onBlur",
        defaultValues: {
            manualCode: initialManualCode,
        },
    }), control = _l.control, handleSubmit = _l.handleSubmit, watch = _l.watch, setValue = _l.setValue, reset = _l.reset, clearErrors = _l.clearErrors, errors = _l.formState.errors;
    var manualCode = watch("manualCode") || "";
    var normalizedAppliedCodes = useMemo(function () {
        return appliedCodes.map(function (code) { return normalizeDiscountCode(code); });
    }, [appliedCodes]);
    useEffect(function () {
        reset({
            manualCode: initialManualCode,
        });
    }, [initialManualCode, reset]);
    var rewards = useMemo(function () {
        var seenCodes = new Set();
        return offers
            .map(function (offer, index) { return toOffer(offer, index); })
            .filter(function (offer) {
            return offer !== null && !isOfferExpired(offer.expiresLabel);
        })
            .filter(function (offer) {
            var normalizedCode = normalizeDiscountCode(offer.code);
            if (seenCodes.has(normalizedCode)) {
                return false;
            }
            seenCodes.add(normalizedCode);
            return true;
        });
    }, [offers]);
    useEffect(function () {
        var requestCodes = rewards.map(function (offer) { return offer.code.trim(); }).filter(function (code) { return code.length > 0; });
        if (requestCodes.length === 0) {
            setOfferRelevanceByCode({});
            setIsRelevanceLoading(false);
            return;
        }
        var isActive = true;
        var fetchOfferRelevance = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, nextMap, responseOffers, _i, responseOffers_1, responseOffer, code, _error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        setIsRelevanceLoading(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, client.post("/cart/discounts/offers/relevance/api", {
                                codes: requestCodes,
                            })];
                    case 2:
                        response = _b.sent();
                        if (!isActive) {
                            return [2 /*return*/];
                        }
                        nextMap = {};
                        responseOffers = Array.isArray((_a = response.data) === null || _a === void 0 ? void 0 : _a.offers) ? response.data.offers : [];
                        for (_i = 0, responseOffers_1 = responseOffers; _i < responseOffers_1.length; _i++) {
                            responseOffer = responseOffers_1[_i];
                            code = String((responseOffer === null || responseOffer === void 0 ? void 0 : responseOffer.code) || "").trim();
                            if (!code) {
                                continue;
                            }
                            nextMap[normalizeDiscountCode(code)] = Boolean(responseOffer === null || responseOffer === void 0 ? void 0 : responseOffer.is_relevant);
                        }
                        setOfferRelevanceByCode(nextMap);
                        return [3 /*break*/, 5];
                    case 3:
                        _error_1 = _b.sent();
                        if (!isActive) {
                            return [2 /*return*/];
                        }
                        setOfferRelevanceByCode({});
                        return [3 /*break*/, 5];
                    case 4:
                        if (isActive) {
                            setIsRelevanceLoading(false);
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        void fetchOfferRelevance();
        return function () {
            isActive = false;
        };
    }, [rewards]);
    var relevantRewards = useMemo(function () {
        if (isRelevanceLoading) {
            return [];
        }
        return rewards.filter(function (offer) {
            return offerRelevanceByCode[normalizeDiscountCode(offer.code)] === true;
        });
    }, [rewards, isRelevanceLoading, offerRelevanceByCode]);
    var nonRelevantRewards = useMemo(function () {
        if (isRelevanceLoading) {
            return [];
        }
        return rewards.filter(function (offer) {
            return offerRelevanceByCode[normalizeDiscountCode(offer.code)] === false;
        });
    }, [rewards, isRelevanceLoading, offerRelevanceByCode]);
    var applyCode = function (code_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([code_1], args_1, true), void 0, function (code, clearManualInput) {
            var trimmedCode, response;
            if (clearManualInput === void 0) { clearManualInput = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        trimmedCode = String(code).trim();
                        if (!trimmedCode || applyingCode) {
                            return [2 /*return*/];
                        }
                        setApplyingCode(trimmedCode);
                        setFeedbackMessage("");
                        setFeedbackType(null);
                        return [4 /*yield*/, onApplyDiscount(trimmedCode)];
                    case 1:
                        response = _a.sent();
                        setApplyingCode(null);
                        setFeedbackMessage(response.success ? "" : response.message);
                        setFeedbackType(response.success ? null : "error");
                        if (response.success && clearManualInput) {
                            setValue("manualCode", "");
                            clearErrors("manualCode");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    var handleManualSubmit = handleSubmit(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, applyCode(values.manualCode, true)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); });
    var removeCode = function (code) { return __awaiter(void 0, void 0, void 0, function () {
        var trimmedCode, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmedCode = String(code || "").trim();
                    if (!trimmedCode || removingCode || applyingCode) {
                        return [2 /*return*/];
                    }
                    setRemovingCode(trimmedCode);
                    setFeedbackMessage("");
                    setFeedbackType(null);
                    return [4 /*yield*/, onRemoveDiscount(trimmedCode)];
                case 1:
                    response = _a.sent();
                    setRemovingCode(null);
                    setFeedbackMessage(response.success ? "" : response.message);
                    setFeedbackType(response.success ? null : "error");
                    return [2 /*return*/];
            }
        });
    }); };
    var appliedCodeList = useMemo(function () {
        var seenCodes = new Set();
        var uniqueCodes = [];
        for (var _i = 0, appliedCodes_1 = appliedCodes; _i < appliedCodes_1.length; _i++) {
            var code = appliedCodes_1[_i];
            var trimmedCode = String(code || "").trim();
            var normalizedCode = normalizeDiscountCode(trimmedCode);
            if (!trimmedCode || seenCodes.has(normalizedCode)) {
                continue;
            }
            seenCodes.add(normalizedCode);
            uniqueCodes.push(trimmedCode);
        }
        return uniqueCodes;
    }, [appliedCodes]);
    var hasAppliedCode = appliedCodeList.length > 0;
    return (React.createElement("section", { className: "vertical-checkout-section", "aria-labelledby": "vertical-discounts-heading" },
        React.createElement("div", { className: "vertical-checkout-section-heading" },
            React.createElement("span", { className: "section-icon", "aria-hidden": "true" },
                React.createElement(ScissorsIcon, null)),
            React.createElement("h2", { id: "vertical-discounts-heading", className: "vertical-checkout-heading" }, "Promotions")),
        isRelevanceLoading ? (React.createElement("p", { hidden: user === null || user === void 0 ? void 0 : user.is_guest, className: "discounts-section-empty-copy" }, "Checking available rewards for your current cart...")) : null,
        React.createElement("ul", { className: "discounts-section-offer-list", "aria-label": "Available rewards" }, relevantRewards.map(function (offer) {
            var isApplied = normalizedAppliedCodes.includes(normalizeDiscountCode(offer.code));
            var isLoading = applyingCode === offer.code;
            var isDisabled = hasAppliedCode || isLoading || applyingCode !== null;
            return (React.createElement("li", { key: offer.id, className: "discounts-section-offer-item ".concat(hasAppliedCode ? "discounts-section-offer-item--disabled" : "") },
                React.createElement("div", { className: "discounts-section-offer-content" },
                    React.createElement("p", { className: "discounts-section-offer-title" }, offer.title),
                    React.createElement("p", { className: "discounts-section-offer-code" },
                        "Code: ",
                        React.createElement("strong", null, offer.code)),
                    offer.expiresLabel ? (React.createElement("p", { className: "discounts-section-offer-meta" },
                        "Expires: ",
                        offer.expiresLabel)) : null),
                React.createElement(RadixButton, { type: "button", className: "discounts-section-apply-button ".concat(isDisabled || isApplied ? "discounts-section-apply-button--disabled" : ""), disabled: isDisabled || isApplied, onClick: function () {
                        void applyCode(offer.code);
                    } }, isApplied ? "Applied" : isLoading ? "Applying..." : "Apply")));
        })),
        React.createElement("form", { className: "discounts-section-form", onSubmit: function (event) {
                event.preventDefault();
                void handleManualSubmit();
            } },
            React.createElement("label", { hidden: true, htmlFor: "vertical-checkout-manual-discount", className: "discounts-section-manual-label" }, "Promo code"),
            React.createElement("div", { className: "discounts-section-manual-controls" },
                React.createElement(Controller, { name: "manualCode", control: control, render: function (_a) {
                        var field = _a.field;
                        return (React.createElement(RadixInput, { label: "Enter Promotion Code", id: "vertical-checkout-manual-discount", type: "text", value: field.value || "", onChange: function (event) {
                                field.onChange(event.target.value);
                                if (feedbackType === "error") {
                                    setFeedbackMessage("");
                                    setFeedbackType(null);
                                }
                            }, onBlur: field.onBlur, placeholder: "Enter promotion code", autoComplete: "off", "aria-describedby": "vertical-checkout-discount-feedback", "aria-invalid": !!errors.manualCode }));
                    } }),
                React.createElement(RadixButton, { type: "submit", className: "discounts-section-apply-button discounts-section-apply-button--manual", disabled: applyingCode !== null || manualCode.trim().length === 0 || !!errors.manualCode }, applyingCode === manualCode.trim() ? "Applying..." : "Apply Code")),
            appliedCodeList.length > 0 ? (React.createElement("div", { className: "discounts-section-applied-wrap", "aria-live": "polite" },
                React.createElement("ul", { className: "discounts-section-applied-list" }, appliedCodeList.map(function (code) { return (React.createElement("li", { key: code, className: "discounts-section-applied-item" },
                    React.createElement("span", { className: "discounts-section-applied-code" },
                        "(",
                        code,
                        ") applied successfully.",
                        React.createElement("button", { type: "button", className: "ml-1 discounts-section-remove-link", disabled: applyingCode !== null || removingCode !== null, onClick: function () {
                                void removeCode(code);
                            } }, removingCode === code ? "Removing..." : "Remove")))); })))) : null),
        React.createElement("p", { id: "vertical-checkout-discount-feedback", className: [
                "discounts-section-feedback",
                errors.manualCode ? "discounts-section-feedback--error" : null,
                feedbackType ? "discounts-section-feedback--".concat(feedbackType) : null,
            ].filter(Boolean).join(" "), role: errors.manualCode ? "alert" : feedbackType === "error" ? "alert" : "status", "aria-live": "polite" }, ((_b = errors.manualCode) === null || _b === void 0 ? void 0 : _b.message) || feedbackMessage),
        React.createElement(RadixModal, { open: nonRelevantModalOpen, onOpenChange: setNonRelevantModalOpen, title: "Offers not relevant to your cart", description: "These offers are available on your account, but your cart does not contain matching items yet.", status: "info" }, nonRelevantRewards.length > 0 ? (React.createElement("ul", { className: "discounts-section-modal-list" }, nonRelevantRewards.map(function (offer) { return (React.createElement("li", { key: "".concat(offer.id, "-not-relevant"), className: "discounts-section-modal-list-item" },
            React.createElement("p", { className: "discounts-section-offer-title" }, offer.title),
            React.createElement("p", { className: "discounts-section-offer-code" },
                "Code: ",
                React.createElement("strong", null, offer.code)),
            offer.expiresLabel ?
                React.createElement("p", { className: "discounts-section-offer-meta" },
                    "Expires: ",
                    offer.expiresLabel) : null)); }))) : (React.createElement("p", { className: "discounts-section-empty-copy" }, "All current offers are applicable to your cart.")))));
};
